import React, { useState } from 'react';
import DOMPurify from 'dompurify';

export default function ResetPassword() {
    const baseURL = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem('authToken'); 
    const strongPasswordRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/;
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [formData, setFormData] = useState({
        password: '',
        confirm_password: '',
    });
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = DOMPurify.sanitize(value);
        

        setFormData({
            ...formData,
            [name]: sanitizedValue,
        });

        if (name === 'password') {
            setIsPasswordValid(strongPasswordRegex.test(value));
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirm_password) {
            setErrorMessage('Passwords do not match');
            return;
        }

        // Validate password before submitting
        if (!isPasswordValid) {
            alert('Password should be at least 8 characters long and contain at least one digit, one uppercase letter, and one special character.');
            return;
        }

        setIsLoading(true);

        try {
            const response = await fetch(`${baseURL}/password-reset`, {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token,
                    password: formData.password,
                    confirm_password: formData.confirm_password,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage(data.message || 'Password reset successful!');
                window.location.href = "/login";
                setErrorMessage('');
            } else {
                setErrorMessage(data.message || 'An error occurred. Please try again.');
            }
        } catch (error) {
            setErrorMessage('An error occurred. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <section className="user-form-part">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4">
                            <div className="user-form-card">
                                <div className="user-form-title">
                                    <h2>Reset Password</h2>
                                </div>
                                <div className="user-form-group">
                                    <form onSubmit={handleResetPassword} className="user-form">
                                        <div className="form-group">
                                            <input
                                                type={showPassword ? 'text' : 'password'}
                                                id="password"
                                                name="password"
                                                className="form-control"
                                                onChange={handleChange}
                                                placeholder="Enter Password"
                                                required
                                                autoComplete="current-password"
                                            />
                                            <span
                                                className={`far fa-fw ${showPassword ? 'fa-eye' : 'fa-eye-slash'} eye-icon toggle-password`}
                                                onClick={togglePasswordVisibility}
                                            ></span>
                                        </div>
                                        <div className="form-group">
                                            <input
                                                type={showPassword ? 'text' : 'password'}
                                                id="confirmPassword"
                                                name="confirm_password"
                                                className="form-control"
                                                onChange={handleChange}
                                                placeholder="Confirm Password"
                                                required
                                                autoComplete="current-password"
                                            />
                                            <span
                                                className={`far fa-fw ${showPassword ? 'fa-eye' : 'fa-eye-slash'} eye-icon toggle-password`}
                                                onClick={togglePasswordVisibility}
                                            ></span>
                                        </div>

                                        {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
                                        {message && <div style={{ color: 'green', marginTop: '10px' }}>{message}</div>}

                                        <div className="col-md-12 text-center">
                                            <button
                                                type="submit"
                                                className="btn-6 view-all-btnn mt-3 text-capitalize"
                                                disabled={isLoading}
                                            >
                                                {isLoading ? (
                                                    <div className="spinner-border" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                ) : (
                                                    'Reset Password'
                                                )}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
